import { Link } from "react-router-dom";
import type { LucideIcon } from "lucide-react";
import { Inbox } from "lucide-react";

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  message?: string;
  ctaLabel?: string;
  ctaTo?: string;
  ctaOnClick?: () => void;
  className?: string;
  compact?: boolean;
}

export const EmptyState = ({
  icon: Icon = Inbox,
  title,
  message,
  ctaLabel,
  ctaTo,
  ctaOnClick,
  className = "",
  compact = false,
}: EmptyStateProps) => {
  return (
    <div
      role="status"
      className={`grid place-items-center rounded-xl border border-dashed border-border bg-card/60 text-center animate-fade-in ${
        compact ? "px-4 py-10" : "px-6 py-16"
      } ${className}`}
    >
      <div className="mb-4 grid h-14 w-14 place-items-center rounded-full bg-primary/10 text-primary">
        <Icon className="h-7 w-7" aria-hidden="true" />
      </div>
      <p className="text-base font-bold text-foreground sm:text-lg">{title}</p>
      {message && <p className="mt-1 max-w-md text-sm text-muted-foreground">{message}</p>}
      {ctaLabel && ctaTo && (
        <Link
          to={ctaTo}
          className="mt-5 inline-flex items-center rounded-full bg-primary px-5 py-2.5 text-sm font-bold text-primary-foreground shadow-premium transition hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          {ctaLabel}
        </Link>
      )}
      {ctaLabel && !ctaTo && ctaOnClick && (
        <button
          type="button"
          onClick={ctaOnClick}
          className="mt-5 inline-flex items-center rounded-full bg-primary px-5 py-2.5 text-sm font-bold text-primary-foreground shadow-premium transition hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          {ctaLabel}
        </button>
      )}
    </div>
  );
};
